// Get Lookbook Users
export const GET_LOOKBOOK_USERS_REQUEST = 'GET_LOOKBOOK_USERS_REQUEST';
export const GET_LOOKBOOK_USERS_DONE = 'GET_LOOKBOOK_USERS_DONE';
export const GET_LOOKBOOK_USERS_FAILED = 'GET_LOOKBOOK_USERS_FAILED';
export const GET_LOOKBOOK_USERS_RESET = 'GET_LOOKBOOK_USERS_RESET';
